import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const emeklilikEtiketi = {
  emekli_degil: 'Emekli Degilim',
  emekli: 'Emekliyim',
  emekliligi_hak_kazandim: 'Emekliliye Hak Kazandim'
};

const telefonFormatla = (deger) => {
  const sadeceSayi = deger.replace(/\D/g, '').slice(0, 11);
  if (sadeceSayi.length === 0) return '';
  if (sadeceSayi.length <= 1) return '0';
  if (sadeceSayi.length <= 4) return '0(' + sadeceSayi.slice(1);
  if (sadeceSayi.length <= 7) return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4);
  if (sadeceSayi.length <= 9) return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4,7) + ' ' + sadeceSayi.slice(7);
  return '0(' + sadeceSayi.slice(1,4) + ')' + sadeceSayi.slice(4,7) + ' ' + sadeceSayi.slice(7,9) + ' ' + sadeceSayi.slice(9,11);
};

const BilgiSatiri = ({ ikon, label, value }) => (
  <div style={{ display: 'flex', gap: '12px', padding: '10px 12px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', alignItems: 'flex-start' }}>
    <span style={{ fontSize: '16px', flexShrink: 0 }}>{ikon}</span>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '2px' }}>{label}</div>
      <div style={{ fontSize: '13px', fontWeight: '500', wordBreak: 'break-word' }}>{value || '—'}</div>
    </div>
  </div>
);

const AdayBilgileriPage = () => {
  const { kullanici } = useAuth();
  const [form, setForm] = useState({
    ad:'', soyad:'', email:'', telefon:'', dogum_tarihi:'',
    emeklilik_durumu:'emekli_degil', maas_beklentisi:'',
    sehir:'', ilce:'', basvuru_pozisyon:'', basvuru_musteri:''
  });
  const [duzenle, setDuzenle] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);

  useEffect(() => {
    axios.get('/api/adaylar/profil').then(r => {
      const a = r.data.aday;
      setForm({
        ad: a.ad || '',
        soyad: a.soyad || '',
        email: a.email || '',
        telefon: a.telefon || '',
        dogum_tarihi: a.dogum_tarihi || '',
        emeklilik_durumu: a.emeklilik_durumu || 'emekli_degil',
        maas_beklentisi: a.maas_beklentisi || '',
        sehir: a.sehir || '',
        ilce: a.ilce || '',
        basvuru_pozisyon: a.basvuru_pozisyon || '',
        basvuru_musteri: a.basvuru_musteri || ''
      });
    }).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.patch('/api/adaylar/profil', form);
      setSonuc({ tip: 'basari', mesaj: 'Bilgileriniz guncellendi.' });
      setDuzenle(false);
    } catch(err) {
      setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' });
    } finally { setYukleniyor(false); }
  };

  const handleTelefon = (val) => setForm({ ...form, telefon: telefonFormatla(val) });

  return (
    <div>
      {/* Banner */}
      <div className="card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg, var(--mavi) 0%, var(--mavi-koyu) 100%)', border: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div className="avatar" data-harf={form.ad?.[0]} style={{ width: '56px', height: '56px', fontSize: '20px', background: 'rgba(255,255,255,0.2)', color: 'white', flexShrink: 0 }}>
            {form.ad?.[0]}{form.soyad?.[0]}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', color: 'white', marginBottom: '4px' }}>{form.ad} {form.soyad}</h2>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', marginBottom: '4px' }}>
              {form.basvuru_pozisyon && <span>🎯 {form.basvuru_pozisyon}</span>}
              {form.basvuru_pozisyon && form.basvuru_musteri && <span> · </span>}
              {form.basvuru_musteri && <span>🏢 {form.basvuru_musteri}</span>}
            </p>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>✉️ {form.email}</p>
          </div>
          {!duzenle && (
            <button className="btn btn-secondary btn-sm" onClick={() => setDuzenle(true)}
              style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '1px solid rgba(255,255,255,0.3)', flexShrink: 0 }}>
              Duzenle
            </button>
          )}
        </div>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1.5rem' }}>{sonuc.mesaj}</div>}

      {!duzenle ? (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
          {/* Kisisel */}
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>👤</div>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Kisisel Bilgiler</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <BilgiSatiri ikon="👤" label="Ad Soyad" value={form.ad + ' ' + form.soyad} />
              <BilgiSatiri ikon="✉️" label="E-posta" value={form.email} />
              <BilgiSatiri ikon="📞" label="Telefon" value={form.telefon} />
              <BilgiSatiri ikon="🎂" label="Dogum Tarihi" value={form.dogum_tarihi ? new Date(form.dogum_tarihi).toLocaleDateString('tr-TR') : null} />
              <BilgiSatiri ikon="🏖️" label="Emeklilik" value={emeklilikEtiketi[form.emeklilik_durumu]} />
            </div>
          </div>

          {/* Basvuru */}
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'var(--yesil-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>💼</div>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Basvuru Bilgileri</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <BilgiSatiri ikon="🎯" label="Basvurulan Pozisyon" value={form.basvuru_pozisyon} />
              <BilgiSatiri ikon="🏢" label="Basvurulan Musteri" value={form.basvuru_musteri} />
              <BilgiSatiri ikon="💰" label="Maas Beklentisi" value={form.maas_beklentisi ? form.maas_beklentisi + ' TL' : null} />
              <BilgiSatiri ikon="📍" label="Sehir / Ilce" value={[form.sehir, form.ilce].filter(Boolean).join(' / ')} />
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '1.5rem' }}>
            {/* Kisisel form */}
            <div className="card">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid var(--border)' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>👤</div>
                <span style={{ fontWeight: '600', fontSize: '14px' }}>Kisisel Bilgiler</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="form-group"><label>Ad *</label><input type="text" value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} required autoComplete="off" /></div>
                  <div className="form-group"><label>Soyad *</label><input type="text" value={form.soyad} onChange={e => setForm({ ...form, soyad: e.target.value })} required autoComplete="off" /></div>
                </div>
                <div className="form-group"><label>E-posta *</label><input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required autoComplete="off" /></div>
                <div className="form-group">
                  <label>Telefon *</label>
                  <input type="tel" value={form.telefon} onChange={e => handleTelefon(e.target.value)} placeholder="0(5xx)xxx xx xx" required autoComplete="off" maxLength={15} />
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginTop: '3px' }}>Format: 0(542)387 19 32</div>
                </div>
                <div className="form-group"><label>Dogum Tarihi</label><input type="date" value={form.dogum_tarihi} onChange={e => setForm({ ...form, dogum_tarihi: e.target.value })} /></div>
                <div className="form-group">
                  <label>Emeklilik Durumu</label>
                  <select value={form.emeklilik_durumu} onChange={e => setForm({ ...form, emeklilik_durumu: e.target.value })}>
                    <option value="emekli_degil">Emekli Degilim</option>
                    <option value="emekli">Emekliyim</option>
                    <option value="emekliligi_hak_kazandim">Emekliliye Hak Kazandim</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Basvuru form */}
            <div className="card">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid var(--border)' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'var(--yesil-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>💼</div>
                <span style={{ fontWeight: '600', fontSize: '14px' }}>Basvuru Bilgileri</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div className="form-group"><label>Basvurulan Pozisyon *</label><input type="text" value={form.basvuru_pozisyon} onChange={e => setForm({ ...form, basvuru_pozisyon: e.target.value })} required placeholder="or. Yazilim Gelistirici" autoComplete="off" /></div>
                <div className="form-group"><label>Basvurulan Musteri *</label><input type="text" value={form.basvuru_musteri} onChange={e => setForm({ ...form, basvuru_musteri: e.target.value })} required placeholder="or. ABC Teknoloji" autoComplete="off" /></div>
                <div className="form-group"><label>Maas Beklentisi (Net TL)</label><input type="text" value={form.maas_beklentisi} onChange={e => setForm({ ...form, maas_beklentisi: e.target.value })} placeholder="or. 25.000" autoComplete="off" /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="form-group"><label>Sehir</label><input type="text" value={form.sehir} onChange={e => setForm({ ...form, sehir: e.target.value })} placeholder="Istanbul" autoComplete="off" /></div>
                  <div className="form-group"><label>Ilce</label><input type="text" value={form.ilce} onChange={e => setForm({ ...form, ilce: e.target.value })} placeholder="Kadikoy" autoComplete="off" /></div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : '✓ Kaydet'}</button>
            <button type="button" className="btn btn-secondary" onClick={() => setDuzenle(false)}>Iptal</button>
          </div>
        </form>
      )}
    </div>
  );
};
export default AdayBilgileriPage;
